import { Seraphim } from '@lima/seraphim-core';
export * from './components';
// export * from './directives';
export * from './utils';
var seraphimConfig = "r = obj\np = obj\ne = some(where(p.eft == allow))\nm = r.obj == p.obj";
export function install(config) {
    if (config === void 0) { config = { seraphimConfig: seraphimConfig }; }
    Seraphim.createInstance(config.seraphimConfig || seraphimConfig);
}
export function addPolicies(expr) {
    Seraphim.instance.addPolicies(expr);
}
